import { env } from '../../env';
import { ROLE } from './Constantes';

const jwtDecode = require('jwt-decode');

const SITE_FRANCE = "F";
const PREFIX_PROFIL = "NXS-HN2-";
const CODE_CLIENT_BPCEA = ["BPO", "ECA", "ECU"];

const UserUtils = {

  getUser() {
    let userInfo = jwtDecode(localStorage.getItem("token"));

    if(!userInfo.code_client) {
      userInfo.code_client = this.getCodeClientsByToken(userInfo);
    }
    
    return userInfo;
  },
  getCodeClientsByToken(userInfo) {
    let codeClients = userInfo.code_client;
    if (!codeClients && userInfo.bpcea_profils && Array.isArray(userInfo.bpcea_profils)) {
      codeClients = [];
      userInfo.bpcea_profils.forEach(profil => {
        if (profil.startsWith(PREFIX_PROFIL)) {
          var clientProfil = profil.substring(PREFIX_PROFIL.length);
          CODE_CLIENT_BPCEA.forEach(codeClient => {
            if (codeClient === clientProfil) {
              codeClients.push(SITE_FRANCE + codeClient);
            }
          });
        }
      });
    }
    return codeClients;
  },
  getRoles() {
    const user = UserUtils.getUser();
    let roles = [];
    if (user && user.resource_access && user.resource_access[env.REACT_APP_KEYCLOAK_ID]) {
      roles = user.resource_access[env.REACT_APP_KEYCLOAK_ID].roles;
    }
    return roles;
  },

  menusAuthorized() {
    let result = this.getRoles().reduce((sum, role) => {
      switch (role) {
        case ROLE.SUIVI_DOSSIER:
          return sum + 1;
        case ROLE.SUIVI_REPARATIONS:
          return sum + 1;
        case ROLE.SUIVI_MESSAGE:
          return sum + 1;
        case ROLE.USER:
          return sum + 1;
        case ROLE.ADMIN:
          return sum + 2;
        case ROLE.REPORTING:
          return sum + 1;
        default:
          return sum;
      }
    }, 0);
    return result;
  }
}

export default UserUtils;